import { supabase } from '../../../services/supabase';

export async function updateCopiedTicketCheckIn(id: string): Promise<boolean> {
  // Update the ticket check-in record
  if (!id) return false;
  const { error } = await supabase
    .from('ticket_check_ins')
    .update({
      is_copied: true,
    })
    .eq('id', id);

  // Return true if no error occurred
  return !error;
}
